const selectors = {
  videoId: '[data-video-id]',
  videoPlayer: '[data-video-player]',
  videoTemplate: '[data-video-template]',
  videoAutoplay: '[data-video-autoplay]',
};

const classes = {
  loading: 'is-loading',
};

class VideoBackground {
  constructor(container) {
    this.container = container;
    this.videoId = this.container.querySelector(selectors.videoId);
    this.videoPlayer = this.container.querySelector(selectors.videoPlayer);
    this.videoTemplate = this.container.querySelector(selectors.videoTemplate);
    this.init();
  }

  init() {
    if (!this.videoId) return;

    /*
      Observe video element and pull it out from its template tag
    */
    const videoObserver = new IntersectionObserver(
      (entries, observer) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const videoMarkup = this.videoTemplate.innerHTML;
            this.videoPlayer.innerHTML = videoMarkup;
            this.video = this.container.querySelector(selectors.videoAutoplay);
            this.videoPlayer.classList.remove(classes.loading);

            this.listen();

            // Stop observing element after it was animated
            observer.unobserve(entry.target);
          }
        });
      },
      {
        root: null,
        rootMargin: '300px',
        threshold: [0, 0.1, 0.25, 0.5, 0.75, 1],
      }
    );

    videoObserver.observe(this.videoPlayer);
  }

  listen() {
    // Force video autoplay on iOS when Low Power Mode is On
    this.container.addEventListener(
      'touchstart',
      () => {
        this.video.play();
      },
      {passive: true}
    );
  }
}

const videoBackground = {
  onLoad() {
    new VideoBackground(this.container);
  },
};

export {videoBackground, VideoBackground};
